"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDropOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16.71 2.29L16 1.57l-.7.74C14.9 2.71 6 12.15 6 20a10 10 0 0010 10 10.08 10.08 0 001.72-.15 10 10 0 005.89-3.36c7.93-9.17-6.29-23.59-6.9-24.2zm5.41 22.9A8 8 0 018 20c0-5.85 5.94-13.15 8-15.52 2.74 2.99 11.9 14 6.12 20.71z" })));
}
exports.default = SvgDropOutline;
//# sourceMappingURL=DropOutline.js.map